import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaSearch,
  FaShieldAlt,
  FaBox,
  FaShip,
  FaFileAlt,
  FaTruck,
  FaAmazon,
  FaGlobeAsia,
  FaHandshake,
  FaEye,
  FaBullseye
} from 'react-icons/fa';
import './About.css';

const About = () => {
  return (
    <div className="about-page">

      {/* ── Page Banner ─────────────────────────────────────────────── */}
      <section
        className="page-banner"
        style={{
          // backgroundImage: `url('/about-banner.png')`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>About Annapurna Axis</h1>

            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span> / </span>
              <span>About Us</span>
            </div>
          </div>
        </div>
      </section>


      {/* ── Who We Are ─────────────────────────────────────────────── */}
      <section className="about-intro">
        <div className="container">

          <div className="intro-grid">

            {/* Logo / Visual */}
            <div className="intro-image">
              <div className="intro-image-placeholder">
                <img
                  src="/logo.png"
                  alt="Annapurna Axis Trading Pvt. Ltd."
                  className="about-logo-img"
                />
              </div>
            </div>


            {/* Company Introduction */}
            <div className="intro-text">

              <span className="section-label">
                Who We Are
              </span>

              <h2 className="section-heading">
                Simplifying Global Trade, Building Trusted Connections
              </h2>

              <p className="intro-paragraph">
                Annapurna Axis Trading Pvt. Ltd. is a professional sourcing
                and international trading company dedicated to making global
                trade simple, reliable, and efficient.
              </p>

              <p className="intro-paragraph">
                We help businesses source products from trusted suppliers,
                manage quality inspection and packaging, coordinate shipping
                and logistics, support customs clearance, and arrange
                door-to-door delivery.
              </p>

              <p className="intro-paragraph">
                We also provide China-to-Amazon FBA warehouse delivery,
                offering businesses an end-to-end solution from supplier to
                final destination.
              </p>

              <p className="intro-paragraph">
                With a focus on reliability, transparency, and long-term
                business relationships, we strive to be a trusted partner
                for businesses looking to expand through global trade.
              </p>


              {/* Locations */}
              <div className="company-locations">

                <div className="location-item">
                  <FaGlobeAsia className="location-icon" />

                  <div>
                    <strong>China Office</strong>
                    <span>Guangzhou, Guangdong, China</span>
                  </div>
                </div>

                <div className="location-item">
                  <FaGlobeAsia className="location-icon" />

                  <div>
                    <strong>Nepal Office</strong>
                    <span>Chauthe, Pokhara, Nepal</span>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </section>


      {/* ── Our Services ───────────────────────────────────────────── */}
      <section className="mission-section">

        <div className="container">

          <span className="section-label center">
            What We Do
          </span>

          <h2 className="section-heading center">
            End-to-End Global Trade Solutions
          </h2>

          <div className="mission-grid">

            <div className="mission-card">
              <div className="mission-icon">
                <FaSearch />
              </div>

              <h3>Product Sourcing</h3>

              <p>
                We find reliable suppliers and source products according
                to your requirements, specifications, and budget.
              </p>
            </div>


            <div className="mission-card">
              <div className="mission-icon">
                <FaShieldAlt />
              </div>

              <h3>Quality Inspection</h3>

              <p>
                We inspect products to help ensure they meet the required
                quality, quantity, and specifications before shipping.
              </p>
            </div>


            <div className="mission-card">
              <div className="mission-icon">
                <FaBox />
              </div>

              <h3>Packaging</h3>

              <p>
                We arrange secure and suitable packaging to help protect
                products during transportation and handling.
              </p>
            </div>


            <div className="mission-card">
              <div className="mission-icon">
                <FaShip />
              </div>

              <h3>Shipping & Logistics</h3>

              <p>
                We coordinate transportation and logistics from the
                supplier to the final destination.
              </p>
            </div>


            <div className="mission-card">
              <div className="mission-icon">
                <FaFileAlt />
              </div>

              <h3>Custom Clearance Support</h3>

              <p>
                We assist with customs documentation and clearance
                processes for smoother shipment handling.
              </p>
            </div>


            <div className="mission-card">
              <div className="mission-icon">
                <FaTruck />
              </div>

              <h3>Door-to-Door Delivery</h3>

              <p>
                We provide end-to-end delivery solutions, coordinating
                shipments from the supplier directly to your doorstep.
              </p>
            </div>


            <div className="mission-card">
              <div className="mission-icon">
                <FaAmazon />
              </div>

              <h3>China to Amazon FBA</h3>

              <p>
                We arrange shipping from China directly to Amazon FBA
                warehouses, simplifying your international fulfillment.
              </p>
            </div>

          </div>
        </div>
      </section>


      {/* ── How We Work ────────────────────────────────────────────── */}
      <section className="journey-section">

        <div className="container">

          <span className="section-label center">
            Our Process
          </span>

          <h2 className="section-heading center">
            From Supplier to Final Destination
          </h2>

          <div className="trade-process">

            <div className="process-step">
              <div className="process-number">01</div>

              <FaSearch className="process-icon" />

              <h3>Source</h3>

              <p>
                Find trusted suppliers and suitable products.
              </p>
            </div>


            <div className="process-step">
              <div className="process-number">02</div>

              <FaShieldAlt className="process-icon" />

              <h3>Inspect</h3>

              <p>
                Check product quality, quantity, and specifications.
              </p>
            </div>


            <div className="process-step">
              <div className="process-number">03</div>

              <FaBox className="process-icon" />

              <h3>Pack</h3>

              <p>
                Arrange secure and appropriate packaging.
              </p>
            </div>


            <div className="process-step">
              <div className="process-number">04</div>

              <FaShip className="process-icon" />

              <h3>Ship</h3>

              <p>
                Coordinate shipping, logistics, and customs.
              </p>
            </div>


            <div className="process-step">
              <div className="process-number">05</div>

              <FaTruck className="process-icon" />

              <h3>Deliver</h3>

              <p>
                Deliver your shipment to its final destination.
              </p>
            </div>

          </div>

          <div className="process-tagline">
            SOURCE <span>•</span> INSPECT <span>•</span> SHIP <span>•</span> DELIVER
          </div>

        </div>
      </section>


      {/* ── Mission Vision Values ─────────────────────────────────── */}
      <section className="mission-section">

        <div className="container">

          <span className="section-label center">
            What Drives Us
          </span>

          <h2 className="section-heading center">
            Our Mission, Vision & Values
          </h2>

          <div className="mission-grid">

            {/* Mission */}
            <div className="mission-card">

              <div className="mission-icon">
                <FaBullseye />
              </div>

              <h3>Our Mission</h3>

              <p>
                To make international sourcing and trading simpler,
                more reliable, and accessible by providing businesses
                with efficient end-to-end sourcing and logistics solutions.
              </p>

            </div>


            {/* Vision */}
            <div className="mission-card">

              <div className="mission-icon">
                <FaEye />
              </div>

              <h3>Our Vision</h3>

              <p>
                To become a trusted global trading and sourcing partner,
                connecting businesses with reliable suppliers and
                efficient international logistics solutions.
              </p>

            </div>


            {/* Values */}
            <div className="mission-card">

              <div className="mission-icon">
                <FaHandshake />
              </div>

              <h3>Our Values</h3>

              <p>
                Reliability, transparency, quality, efficiency, and
                long-term relationships are at the heart of everything
                we do.
              </p>

            </div>

          </div>
        </div>
      </section>


      {/* ── Why Choose Us ─────────────────────────────────────────── */}
      <section className="leadership-section">

        <div className="container">

          <span className="section-label center">
            Why Annapurna Axis
          </span>

          <h2 className="section-heading center">
            Your Trusted Partner in Global Trade
          </h2>

          <div className="leadership-grid">

            <div className="leader-card founder">

              <div className="leader-content">

                <h3 className="leader-name">
                  Reliable Sourcing
                </h3>

                <p className="leader-bio">
                  We help businesses identify and connect with reliable
                  suppliers based on their product requirements and budget.
                </p>

                <ul className="leader-points">
                  <li>Supplier sourcing</li>
                  <li>Product verification</li>
                  <li>Requirement-based procurement</li>
                </ul>

              </div>
            </div>


            <div className="leader-card next-gen">

              <div className="leader-content">

                <h3 className="leader-name">
                  Complete Logistics Support
                </h3>

                <p className="leader-bio">
                  From inspection and packaging to shipping, customs,
                  and final delivery, we coordinate the complete process.
                </p>

                <ul className="leader-points">
                  <li>International shipping</li>
                  <li>Custom clearance support</li>
                  <li>Door-to-door delivery</li>
                </ul>

              </div>
            </div>

          </div>


          <div className="leadership-tagline">
            Making global trade simpler, one shipment at a time.
          </div>

        </div>
      </section>


      {/* ── Final CTA ─────────────────────────────────────────────── */}
      <section className="about-cta">

        <div className="container">

          <h2>
            Ready to Simplify Your Global Trade?
          </h2>

          <p>
            Let Annapurna Axis handle your sourcing, logistics,
            and delivery from supplier to final destination.
          </p>

          <Link to="/contact" className="btn-dark-map">
            Get in Touch
          </Link>

        </div>

      </section>

    </div>
  );
};

export default About;